/**
 * 合作方定制配置中心（独立分支专版）
 */
export const PARTNER_KEYS = {
  LIMEPAY: 'LIMEPAY'
};

export const PARTNER_CONFIG = {
  key: PARTNER_KEYS.LIMEPAY,
  name: 'LimePay',
  themeClass: 'theme-blue',
  hideHeaderTitle: true,              // 隐藏顶部导航系统名称
  hideOfficialCustomerService: true,  // 隐藏官方客服电话
  hideReceiptModule: true,            // 隐藏收款方式模块与快捷入口
};

export const PARTNER_CONFIGS = {
  [PARTNER_KEYS.LIMEPAY]: PARTNER_CONFIG
};

/**
 * 在当前定制专版分支下，默认返回该定制配置
 */
export function resolvePartnerConfig(merchantDetail = {}) {
  return PARTNER_CONFIG;
}



// WEBPACK FOOTER //
// ./src/common/js/partnerConfig.js